/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * FINRA Market Data API
 * Market data aggregation backend for FINRA data sources
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DetailNotFoundErrorResponse,
  ETFChartData,
  ETFDetail,
  GetETFChartDataParams,
  HTTPValidationError,
  InternalErrorResponse,
  UpstreamAuthenticationFailedErrorResponse,
  UpstreamBadGatewayErrorResponse,
  UpstreamNotFoundErrorResponse,
  UpstreamUnavailableErrorResponse,
  WrongInvestmentTypeErrorResponse
} from '../fINRAMarketDataAPI.schemas.ts';

import { apiFetch } from '../../../lib/api-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getETFDetailResponse200 = {
  data: ETFDetail
  status: 200
}

export type getETFDetailResponse404 = {
  data: DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse
  status: 404
}

export type getETFDetailResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getETFDetailResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getETFDetailResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getETFDetailResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getETFDetailResponseSuccess = (getETFDetailResponse200) & {
  headers: Headers;
};
export type getETFDetailResponseError = (getETFDetailResponse404 | getETFDetailResponse422 | getETFDetailResponse500 | getETFDetailResponse502 | getETFDetailResponse503) & {
  headers: Headers;
};

export type getETFDetailResponse = (getETFDetailResponseSuccess | getETFDetailResponseError)

export const getGetETFDetailUrl = (symbol: string,) => {




  return `/api/v1/etf/${symbol}/detail`
}

/**
 * Get the full ETF detail page response for a given symbol.
 *
 * Aggregates data from Morningstar Investment Details API and Market Data API
 * into a structured response for the ETF detail page.
 *
 * Args:
 *     symbol: The ETF trading symbol (e.g., "FTEC", "SPY")
 *     morningstar: Injected MorningstarClient instance
 *     morningstar_market_data: Injected MorningstarMarketDataClient instance
 *     edgar: Injected EDGARClient instance
 * Returns:
 *     ETFDetail response model, with sections
 *     Chart data is served by a separate lazy-loaded endpoint.
 *     CMS content is not included in this response.
 *
 * Raises:
 *     404: Symbol not found in Morningstar
 *     500: Morningstar API error or authentication failure
 * @summary Get Etf Detail
 */
export const getETFDetail = async (symbol: string, options?: RequestInit): Promise<getETFDetailResponse> => {

  return apiFetch<getETFDetailResponse>(getGetETFDetailUrl(symbol),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetETFDetailQueryKey = (symbol: string,) => {
    return [
    `/api/v1/etf/${symbol}/detail`
    ] as const;
    }


export const getGetETFDetailQueryOptions = <TData = Awaited<ReturnType<typeof getETFDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFDetail>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetETFDetailQueryKey(symbol);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getETFDetail>>> = ({ signal }) => getETFDetail(symbol, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: symbol !== null && symbol !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getETFDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetETFDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getETFDetail>>>
export type GetETFDetailQueryError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetETFDetail<TData = Awaited<ReturnType<typeof getETFDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getETFDetail>>,
          TError,
          Awaited<ReturnType<typeof getETFDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETFDetail<TData = Awaited<ReturnType<typeof getETFDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getETFDetail>>,
          TError,
          Awaited<ReturnType<typeof getETFDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETFDetail<TData = Awaited<ReturnType<typeof getETFDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFDetail>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Etf Detail
 */

export function useGetETFDetail<TData = Awaited<ReturnType<typeof getETFDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFDetail>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetETFDetailQueryOptions(symbol,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getETFChartDataResponse200 = {
  data: ETFChartData
  status: 200
}

export type getETFChartDataResponse404 = {
  data: UpstreamNotFoundErrorResponse
  status: 404
}

export type getETFChartDataResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getETFChartDataResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getETFChartDataResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getETFChartDataResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getETFChartDataResponseSuccess = (getETFChartDataResponse200) & {
  headers: Headers;
};
export type getETFChartDataResponseError = (getETFChartDataResponse404 | getETFChartDataResponse422 | getETFChartDataResponse500 | getETFChartDataResponse502 | getETFChartDataResponse503) & {
  headers: Headers;
};

export type getETFChartDataResponse = (getETFChartDataResponseSuccess | getETFChartDataResponseError)

export const getGetETFChartDataUrl = (symbol: string,
    params: GetETFChartDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/etf/${symbol}/chart?${stringifiedParams}` : `/api/v1/etf/${symbol}/chart`
}

/**
 * Get historical OHLCV chart data for an ETF. Lazy-loaded by the detail page.
 *
 * Args:
 *     symbol: The ETF trading symbol (e.g., "FTEC", "SPY")
 *     morningstar: Injected MorningstarMarketDataClient instance
 *     start_date: Start of date range in DD-MM-YYYY format (e.g., "01-01-2025")
 *     end_date: End of date range in DD-MM-YYYY format (e.g., "31-12-2025")
 *
 * Returns:
 *     ETFChartData wrapping the Morningstar historical price response
 *
 * Raises:
 *     404: Symbol not found in Morningstar
 *     500: Morningstar API error or authentication failure
 * @summary Get Etf Chart
 */
export const getETFChartData = async (symbol: string,
    params: GetETFChartDataParams, options?: RequestInit): Promise<getETFChartDataResponse> => {

  return apiFetch<getETFChartDataResponse>(getGetETFChartDataUrl(symbol,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetETFChartDataQueryKey = (symbol: string,
    params?: GetETFChartDataParams,) => {
    return [
    `/api/v1/etf/${symbol}/chart`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetETFChartDataQueryOptions = <TData = Awaited<ReturnType<typeof getETFChartData>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(symbol: string,
    params: GetETFChartDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFChartData>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetETFChartDataQueryKey(symbol,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getETFChartData>>> = ({ signal }) => getETFChartData(symbol,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: symbol !== null && symbol !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getETFChartData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetETFChartDataQueryResult = NonNullable<Awaited<ReturnType<typeof getETFChartData>>>
export type GetETFChartDataQueryError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetETFChartData<TData = Awaited<ReturnType<typeof getETFChartData>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetETFChartDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFChartData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getETFChartData>>,
          TError,
          Awaited<ReturnType<typeof getETFChartData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETFChartData<TData = Awaited<ReturnType<typeof getETFChartData>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetETFChartDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFChartData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getETFChartData>>,
          TError,
          Awaited<ReturnType<typeof getETFChartData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetETFChartData<TData = Awaited<ReturnType<typeof getETFChartData>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetETFChartDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFChartData>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Etf Chart
 */

export function useGetETFChartData<TData = Awaited<ReturnType<typeof getETFChartData>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetETFChartDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getETFChartData>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetETFChartDataQueryOptions(symbol,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






